module.exports = __webpack_public_path__ + "static/media/top-brand-22.d3441e03.png";